import React,{Fragment, Component} from 'react';
import {Link} from 'react-router-dom';
import Header from '../Layout/Header';
import Footer from '../Layout/Footer';
import PageTitle from '../Layout/PageTitle';
import bnr1 from './../../images/line2.png';
import team1 from './../../images/team/pic1.jpg';
import team2 from './../../images/team/pic2.jpg';
import team3 from './../../images/team/pic3.jpg';
import team4 from './../../images/team/pic4.jpg';

const teamBlog = [
	{ image: team1, name: "Ravind Thukral", },
	{ image: team2, name: "Sapna",},
	{ image: team3, name: "Khushi Tiwari", },
	{ image: team4, name: "Anjali Awasthi", },
	
];

class Teachers extends Component{
	render(){
		return(
			<Fragment>
				<Header />
					<div className="page-content">
						<PageTitle motherMenu="Teachers" activeMenu="Teachers" />
						<div className="content-block">
							<div className="section-full bg-white content-inner" style={{backgroundImage:"url("+ bnr1 +")", backgroundSize:"contain", backgroundRepeat: "no-repeat", backgroundPosition: "center"}}>
							<div className="container">
								
								<div className="class-info">
									<div className="dlab-post-title ">
										<h2 className="post-title m-t0" style={{ color:"#ed5ab0"}}>About the Teachers</h2>
									</div>

									<div className="dlab-post-text">
										<p>
											Kimaya only hires qualified teachers who are equally passionate about the well being and learning of children, this ensures an
											atmosphere of trust and love and creates a safe space for the children to nurture and grow. Our School’s director herself holds
											a teaching experience of more than 25 years, the learning from all that experience surely trickles down the hierarchy and our
											teachers are wise enough to make the most of it. This immense learning coupled with the energy of our staff creates a flourishing
											ambience which catapults children into a bright and lively future.
										</p>
									</div>
								</div>
									<div className="row">
										{teamBlog.map((data,index)=>(
											<div className="col-lg-3 col-md-6 col-sm-6" key={index}>
												 <div className="dlab-box box-frame1 team-box m-b40">
													<div className="dlab-thum"> 
														<Link to={"/teachers-details"}>
															<img src={data.image} alt="" />
														</Link>
														<div className="overlay-bx">
															<h5 className="team-title" style={{ color:"#ed5ab0"}}>{data.name}</h5>
															<span className="team-info">Teacher</span>
															{/* <ul className="list-inline">
																<li><Link to={"#"}><i className="fa fa-facebook"></i></Link></li>
																<li><Link to={"#"}><i className="fa fa-google-plus"></i></Link></li>
																<li><Link to={"#"}><i className="fa fa-linkedin"></i></Link></li>
																<li><Link to={"#"}><i className="fa fa-instagram"></i></Link></li>
																<li><Link to={"#"}><i className="fa fa-twitter"></i></Link></li>
															</ul> */}
														</div>
													</div>
												</div>
											</div>
										))}
									</div>	
								</div>
							</div>
						</div>
					</div>
				<Footer />
			</Fragment>
		)
	}
}

export default Teachers;